export default __webpack_public_path__ + "static/media/destinations.7ccfdf3c.svg";